import {
  HomeGamesWrapper,
  getSkeletonLoaderImageStyle,
} from '@/widgets/game-sections/ui/styles';
import { Box } from '@/shared/ui/box/Box';
import { Section, SectionBlocks } from '@/widgets/game-section/ui/styles';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';

const GameSectionsSkeleton = () => {
  const styleForImage = getSkeletonLoaderImageStyle();

  return (
    <HomeGamesWrapper>
      {[1, 2, 3].map((el) => {
        return (
          <Box key={`box_${el}`}>
            <SectionBlocks>
              {[4, 5].map((item) => {
                return (
                  <div key={`sb_${item}`}>
                    <SkeletonLoader width={148} height={36} />
                  </div>
                );
              })}
            </SectionBlocks>
            {[6, 7].map((row) => {
              return (
                <Section key={`row_${row}`} $hasScroll={true} $rows={2}>
                  {[...Array(6)].map((_, index) => (
                    <SkeletonLoader
                      key={`card_${index}`}
                      style={styleForImage}
                      width="100%"
                      height="100%"
                    />
                  ))}
                </Section>
              );
            })}
          </Box>
        );
      })}
    </HomeGamesWrapper>
  )
}

export { GameSectionsSkeleton };
